import { isAddress } from 'ethers';
import * as Yup from 'yup';

export const ethAddressValidator = (value: string | undefined): boolean | Yup.ValidationError => {

    if (!value || !isAddress(value)) {
        return false;
    }
    return true;
};